import { Box, Text, Tooltip } from '@modusign/design-system';

export default function DataLabelTooltip() {
  return (
    <Tooltip
      content={
        <Text fontSize="sm">
          입력란의 이름입니다. 입력값을 추출하거나 API로 요청할 때 사용됩니다.
        </Text>
      }
      placement="right"
      scale="md"
    >
      <Box
        as="i"
        className="fa fa-question-circle "
        color="darkGray100"
        data-testid="checkbox-group-selection-count-help-icon"
        paddingLeft={1}
      />
    </Tooltip>
  );
}
